import React, { useState } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { API_BASE } from "../api/apiConfig";

const Allexperts = () => {
  const [viewMode, setViewMode] = useState('grid');
  const [showFilters, setShowFilters] = useState(false);
  const [rating, setRating] = useState(3.9);

  const experts = [
    {
      id: 1,
      name: 'Sarah Patel',
      rating: 4.9,
      location: 'Delhi',
      image:
        'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/london-premium-8jeoTGo78lLM8UyAaEM58O7L1pk3IK.jpg',
      avatar:
        'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/member-1-bOpGjZCsPuoiXPcWozfOLLcloeHRto.jpg',
      tags: ['Historical', 'Cultural', 'Photography'],
      languages: 'English, Hindi',
      responseTime: 'Responds within 2 hours',
      description:
        'History enthusiast and Delhi native with 8+ years guiding experience. Specialized in historical monuments and cultural experiences.',
    },
    // Add more expert objects here...
  ];

  return (
    <>
     <style>{`
        .to-primary\\/90 {
          --tw-gradient-to: hsl(var(--primary) / 0.9) var(--tw-gradient-to-position);
        }
      `}</style>


      <Header />
      <main className="min-h-screen bg-white">
        {/* Banner */}
        <section className="relative overflow-hidden bg-gradient-to-r from-slate-900 to-primary/90">
  <div className="absolute inset-0 bg-[url('/abstract-geometric-shapes.png')] bg-cover opacity-20" />
  <div className="absolute top-20 right-10 w-64 h-64 bg-white/10 rounded-full blur-3xl" />
  <div className="absolute bottom-10 left-10 w-40 h-40 bg-primary/30 rounded-full blur-3xl" />
  <div className="container mx-auto px-4 py-8 md:py-16 lg:py-24 relative z-10">
    <div className="grid md:grid-cols-2 gap-8 items-center">
      <div>
        <a
          className="mb-6 inline-flex items-center text-white/80 hover:text-white transition-colors text-sm bg-white/10 px-4 py-1.5 rounded-full backdrop-blur-sm"
          href="/experts"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-arrow-left mr-1.5 h-3.5 w-3.5"
          >
            <path d="m12 19-7-7 7-7" />
            <path d="M19 12H5" />
          </svg>
          <span>Back to Experts Home</span>
        </a>
        <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white leading-tight mb-4 md:mb-6">
          Connect with{" "}
          <span className="inline-block bg-white text-primary px-2 py-1 rounded-md">
            Local Experts
          </span>
          <span className="block mt-2">for Authentic Experiences</span>
        </h1>
        <p className="text-white/90 text-base md:text-lg mb-4 md:mb-8 max-w-xl">
          Discover personalized travel experiences curated by our community of
          verified local experts who know their destinations inside out.
        </p>
        <div className="relative w-full max-w-2xl mx-auto mt-4 sm:mt-6">
          <div className="flex items-center overflow-hidden rounded-full border border-white/20 bg-white/10 backdrop-blur-md shadow-lg transition-all duration-300 hover:border-primary/30 focus-within:border-primary/50 focus-within:ring-2 focus-within:ring-primary/20">
            <div className="flex-1 relative">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-search absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-white/70"
              >
                <circle cx={11} cy={11} r={8} />
                <path d="m21 21-4.3-4.3" />
              </svg>
              <input
                placeholder="Search for travel experts by name, location or specialty..."
                className="w-full bg-transparent py-3 pl-10 pr-4 text-sm sm:text-base text-white placeholder:text-white/60 focus:outline-none"
                type="text"
                defaultValue=""
              />
            </div>
            <button className="h-full px-4 sm:px-6 py-3 bg-primary hover:bg-primary/90 text-white text-sm sm:text-base font-medium transition-colors duration-300 flex items-center gap-2">
              Search
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-arrow-right h-4 w-4"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </button>
          </div>
          <div className="mt-2 sm:mt-3 flex flex-wrap items-center gap-1 sm:gap-2 justify-center text-xs sm:text-sm">
            <span className="text-white/70">Popular:</span>
            <button className="px-2 py-1 rounded-full bg-white/10 hover:bg-white/20 text-white/90 hover:text-white transition-colors duration-300">
              Delhi
            </button>
            <button className="px-2 py-1 rounded-full bg-white/10 hover:bg-white/20 text-white/90 hover:text-white transition-colors duration-300">
              Mumbai
            </button>
            <button className="px-2 py-1 rounded-full bg-white/10 hover:bg-white/20 text-white/90 hover:text-white transition-colors duration-300">
              Rajasthan
            </button>
            <button className="px-2 py-1 rounded-full bg-white/10 hover:bg-white/20 text-white/90 hover:text-white transition-colors duration-300">
              Kerala
            </button>
            <button className="px-2 py-1 rounded-full bg-white/10 hover:bg-white/20 text-white/90 hover:text-white transition-colors duration-300">
              Himalayas
            </button>
          </div>
        </div>
      </div>
      <div className="hidden md:block relative">
        <div className="relative z-10 bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 shadow-xl">
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-primary/20 rounded-full blur-xl" />
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-white/10 rounded-full blur-xl" />
          <h3 className="text-white text-xl font-medium mb-4">
            Featured Travel Experts
          </h3>
          <div className="relative mb-6 rounded-xl overflow-hidden bg-white/10">
            <div className="flex items-start p-4">
              <div className="relative mr-4">
                <span className="relative flex shrink-0 overflow-hidden rounded-full h-16 w-16 border-2 border-white">
                  <img
                    className="aspect-square h-full w-full"
                    alt="Arjun Negi"
                    src="/assets/images/member-profile-1.png"
                  />
                </span>
                <div className="absolute -bottom-1 -right-1 bg-amber-500 text-white text-xs font-medium rounded-full px-1.5 py-0.5 border border-white">
                  4.9
                </div>
              </div>
              <div className="flex-1">
                <div className="flex items-center mb-1">
                  <h4 className="text-white font-medium">Arjun Negi</h4>
                  <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 ml-2 bg-amber-500/80 text-white text-xs">
                    Featured
                  </div>
                </div>
                <div className="flex items-center text-white/80 text-xs mb-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-map-pin h-3 w-3 mr-1"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                    <circle cx={12} cy={10} r={3} />
                  </svg>
                  <span>Rishikesh</span>
                </div>
                <div className="flex flex-wrap gap-1 mb-2">
                  <span className="text-xs bg-white/20 text-white px-2 py-0.5 rounded-full">
                    Adventure
                  </span>
                  <span className="text-xs bg-white/20 text-white px-2 py-0.5 rounded-full">
                    Yoga
                  </span>
                  <span className="text-xs bg-white/20 text-white px-2 py-0.5 rounded-full">
                    Spiritual
                  </span>
                </div>
                <p className="text-white/80 text-xs line-clamp-2">
                  Adventure guide and yoga instructor with deep knowledge of
                  Rishikesh's spiritual and adventure offerings.
                </p>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-white/10 rounded-lg p-3 flex items-center">
              <span className="relative flex shrink-0 overflow-hidden rounded-full h-10 w-10 mr-3 border border-white/50">
                <img
                  className="aspect-square h-full w-full"
                  alt="Sarah Patel"
                  src="/assets/images/member-1.png"
                />
              </span>
              <div>
                <h5 className="text-white text-sm font-medium">Sarah Patel</h5>
                <div className="flex items-center text-white/70 text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-map-pin h-2.5 w-2.5 mr-0.5"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                    <circle cx={12} cy={10} r={3} />
                  </svg>
                  <span>Delhi</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 rounded-lg p-3 flex items-center">
              <span className="relative flex shrink-0 overflow-hidden rounded-full h-10 w-10 mr-3 border border-white/50">
                <span className="flex h-full w-full items-center justify-center rounded-full bg-muted">
                  P
                </span>
              </span>
              <div>
                <h5 className="text-white text-sm font-medium">Priya Nair</h5>
                <div className="flex items-center text-white/70 text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-map-pin h-2.5 w-2.5 mr-0.5"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                    <circle cx={12} cy={10} r={3} />
                  </svg>
                  <span>Kochi</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 rounded-lg p-3 flex items-center">
              <span className="relative flex shrink-0 overflow-hidden rounded-full h-10 w-10 mr-3 border border-white/50">
                <span className="flex h-full w-full items-center justify-center rounded-full bg-muted">
                  A
                </span>
              </span>
              <div>
                <h5 className="text-white text-sm font-medium">Ananya Das</h5>
                <div className="flex items-center text-white/70 text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-map-pin h-2.5 w-2.5 mr-0.5"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                    <circle cx={12} cy={10} r={3} />
                  </svg>
                  <span>Varanasi</span>
                </div>
              </div>
            </div>
            <div className="bg-white/10 rounded-lg p-3 flex items-center">
              <span className="relative flex shrink-0 overflow-hidden rounded-full h-10 w-10 mr-3 border border-white/50">
                <img
                  className="aspect-square h-full w-full"
                  alt="Aisha Khan"
                  src="/assets/images/member-profile-1.png"
                />
              </span>
              <div>
                <h5 className="text-white text-sm font-medium">Aisha Khan</h5>
                <div className="flex items-center text-white/70 text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-map-pin h-2.5 w-2.5 mr-0.5"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                    <circle cx={12} cy={10} r={3} />
                  </svg>
                  <span>Lucknow</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

        {/* ./Banner */}
        <div className="py-8 md:py-12 lg:py-16">
          <div className="container mx-auto px-4">
            <div className="mb-8">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
                <div>
                  <h2 className="text-3xl font-bold text-slate-800 mb-1">Our Travel Experts</h2>
                  <p className="text-slate-500 text-sm">Explore and connect with top-rated travel advisors</p>
                </div>
                <div className="flex gap-2 flex-wrap">
                  <div className="flex border border-slate-300 rounded-md overflow-hidden">
                    <button
                      onClick={() => setViewMode('grid')}
                      className={`px-3 py-1 ${viewMode === 'grid' ? 'bg-primary/10 text-primary' : 'bg-white text-slate-600'}`}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-grid3x3 h-4 w-4">
                                    <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                                    <path d="M3 9h18"></path>
                                    <path d="M3 15h18"></path>
                                    <path d="M9 3v18"></path>
                                    <path d="M15 3v18"></path>
                                </svg>
                    </button>
                    <button
                      onClick={() => setViewMode('list')}
                      className={`px-3 py-1 ${viewMode === 'list' ? 'bg-primary/10 text-primary' : 'bg-white text-slate-600'}`}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list h-4 w-4">
                                    <line x1="8" x2="21" y1="6" y2="6"></line>
                                    <line x1="8" x2="21" y1="12" y2="12"></line>
                                    <line x1="8" x2="21" y1="18" y2="18"></line>
                                    <line x1="3" x2="3.01" y1="6" y2="6"></line>
                                    <line x1="3" x2="3.01" y1="12" y2="12"></line>
                                    <line x1="3" x2="3.01" y1="18" y2="18"></line>
                                </svg>
                    </button>
                  </div>
                  <button
                    onClick={() => setShowFilters(!showFilters)}
                    className="px-4 py-2 border border-slate-300 rounded-md text-sm text-slate-700"
                  >
                    {showFilters ? 'Hide Filters' : 'Show Filters'}
                  </button>
                </div>
              </div>

              {showFilters && (
                <div className="mb-6 p-6 rounded-xl border bg-gradient-to-r from-slate-50 to-white shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-slate-600 font-medium">Filter by Minimum Rating</h3>
                    <span className="text-primary font-semibold text-sm">{rating}+</span>
                  </div>
                  <input
                    type="range"
                    min="3"
                    max="5"
                    step="0.1"
                    value={rating}
                    onChange={(e) => setRating(parseFloat(e.target.value))}
                    className="w-full"
                  />
                </div>
              )}

              <div className={`grid gap-6 ${viewMode === 'grid' ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4' : 'grid-cols-1'}`}>
                {experts.filter((expert) => expert.rating >= rating).map((expert) => (
                  <div key={expert.id} className="group">
                    <div className="relative overflow-hidden rounded-xl transition-all duration-300 hover:shadow-lg bg-white border border-slate-100">
                      <div className="relative h-52 w-full overflow-hidden">
                        <img
                          src={expert.image}
                          alt={`${expert.name}'s location`}
                          className="object-cover transition-transform duration-700 group-hover:scale-110 absolute inset-0 w-full h-full"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                        <div className="absolute top-3 left-3">
                          <div className="inline-flex items-center rounded-full bg-amber-500 text-white font-medium px-2 py-0.5 text-xs">
                            Featured Expert
                          </div>
                        </div>
                        <button className="absolute top-3 right-3 h-8 w-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white hover:text-primary transition-colors">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-heart h-4 w-4">
                            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                        </svg>

                        </button>
                        <div className="absolute bottom-0 left-0 right-0 p-4">
                          <div className="flex items-center gap-3 mb-2">
                            <span className="relative flex shrink-0 overflow-hidden rounded-full h-12 w-12 border-2 border-white">
                              <img src={expert.avatar} alt={expert.name} className="h-full w-full object-cover" />
                            </span>
                            <div>
                              <h3 className="text-white font-medium group-hover:text-primary/90 flex items-center">
                                {expert.name}
                                <span className="ml-1 text-primary">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big h-3 w-3 fill-primary text-white">
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                    <path d="m9 11 3 3L22 4"></path>
                                  </svg>
                                </span>
                              </h3>
                              <div className="flex items-center text-white/80 text-sm">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin h-3 w-3 mr-1">
                                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                                    <circle cx="12" cy="10" r="3"></circle>
                                </svg>
                                {expert.location}
                              </div>
                            </div>
                          </div>
                          <div className="absolute bottom-4 right-4 bg-white/20 backdrop-blur-sm rounded-full px-2 py-1 flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-star h-3 w-3 fill-amber-400 text-amber-400 mr-1">
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                            </svg>
                            <span className="text-white text-sm font-medium">{expert.rating}</span>
                          </div>
                        </div>
                      </div>
                      <div className="p-4">
                        <div className="mb-3 flex flex-wrap gap-1.5">
                          {expert.tags.map((tag, index) => (
                            <div key={index} className="bg-slate-50 text-xs font-normal text-slate-600 hover:bg-slate-100 px-2 py-0 rounded-full">
                              {tag}
                            </div>
                          ))}
                        </div>
                        <p className="mb-4 text-sm text-slate-600 line-clamp-2">{expert.description}</p>
                        <div className="grid grid-cols-2 gap-2 mb-4 text-xs text-slate-500">
                          <div className="flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe h-3 w-3 text-primary">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                                <path d="M2 12h20"></path>
                            </svg>
                            <span>{expert.languages}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock h-3 w-3 text-primary">
                                <circle cx="12" cy="12" r="10"></circle>
                                <polyline points="12 6 12 12 16 14"></polyline>
                            </svg>
                            <span>{expert.responseTime}</span>
                          </div>
                        </div>
                        <div className='btn-block'>
                          {/* <a href={`ExpertsDtl/${expert.name.toLowerCase().replace(/\s+/g, '-')}`}> */}
                          <a href={`ExpertsDtl`}>
                            <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 px-4 py-2 w-full bg-primary text-white hover:bg-primary/90 text-xs h-9">
                              View Profile
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right ml-1 h-3.5 w-3.5">
                                <path d="m9 18 6-6-6-6"></path>
                              </svg>
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                {experts.filter((expert) => expert.rating >= rating).length === 0 && (
                  <div className="text-center text-slate-500 col-span-full">No experts match the filter.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Allexperts;
